import {memo, useCallback} from 'react';
import {StyleSheet, View, FlatList} from 'react-native';
import Styles from '../../Styles';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import {IsConnectedProps} from 'src/types/Screen';
import {getDescriber} from 'src/components/elements/home/descriptors/campusComponents/DescriptorType';
import VendingMachineView from 'src/components/elements/vending/VendingMachineView';

type VendingMachineListProps = IsConnectedProps & {
  locations: CampusLocationType[];
  selectedLocation: number;
  onLocationClick: (index: number) => void;
};

const {getScanAndPayTile} = getDescriber();

const VendingMachineList = memo((props: VendingMachineListProps) => {
  const renderItem = useCallback(
    ({item, index}: {index: number; item: CampusLocationType}) => (
      <VendingMachineView
        location={item}
        isSelected={props.selectedLocation === index}
        onLocationClick={props.onLocationClick}
        index={index}
      />
    ),
    [props.onLocationClick],
  );

  return (
    <View style={[styles.container, getScanAndPayTile()['listContainer']]}>
      <FlatList
        renderItem={renderItem}
        style={styles.vendingListView}
        data={props.locations}
        keyExtractor={(item) => item?.id ?? item?.locationId}
        initialNumToRender={4}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'flex-start',
    marginBottom: Styles.Spacing.m1,
    justifyContent: 'flex-start',
  },
  vendingListView: {
    width: '100%',
  },
});

export default VendingMachineList;
